import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export const FREQ_LABEL = { weekly: "Weekly", monthly: "Monthly", annually: "Annually" };
export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const TIMES = Array.from({ length: 96 }, (_, i) => `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`);
export const fmtTime12 = (t) => { const [h, m] = t.split(":").map(Number); return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };
export const overdueText = (o) => (!o || o.enabled === false ? "Weekly overdue notices are turned off" : `Overdue notices go out every ${DAYS[o.weekday ?? 1]} at ${fmtTime12(o.time || "09:00")} Eastern`);
export const blankSchedule = () => ({ frequency: "annually", due_date: "", first_occurrence: "", lead_days: 30, channels: ["email"], contact_ids: [], group_ids: [] });

// Shared recurring-service data for the Service page: delivery status, contacts, groups and this property's schedules.
export function useRecurring(propertyId) {
  const [status, setStatus] = useState({ can_manage: false, leads: { weekly: [1, 3, 6], monthly: [15], annually: [15, 30, 60, 90] }, overdue: { enabled: true, weekday: 1, time: "09:00" } });
  const [contacts, setContacts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [schedules, setSchedules] = useState([]);

  const loadPeople = useCallback(async () => {
    const [c, g] = await Promise.all([api.get("/service/recurring/contacts"), api.get("/service/recurring/groups")]);
    setContacts(c.data); setGroups(g.data);
  }, []);
  const loadSchedules = useCallback(async () => {
    if (!propertyId) { setSchedules([]); return; }
    const { data } = await api.get("/service/recurring/schedules", { params: { property_id: propertyId } });
    setSchedules(data);
  }, [propertyId]);

  const loadStatus = useCallback(() => api.get("/service/recurring/status").then(({ data }) => setStatus(data)).catch(() => {}), []);
  useEffect(() => {
    loadStatus();
    loadPeople().catch(() => {});
  }, [loadPeople, loadStatus]);
  useEffect(() => { loadSchedules().catch(() => {}); }, [loadSchedules]);

  return { status, contacts, groups, schedules, loadPeople, loadSchedules, loadStatus };
}
